import ProfileImage from './ProfilePic';

export default ProfileImage;
